import { render } from "./TemporaryWorkerM.vue?vue&type=template&id=1cc3981f&scoped=true"
import script from "./TemporaryWorkerM.vue?vue&type=script&lang=js"
export * from "./TemporaryWorkerM.vue?vue&type=script&lang=js"

import "./TemporaryWorkerM.vue?vue&type=style&index=0&id=1cc3981f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc3981f"]])

export default __exports__